import Types from "../types";

export const setNavbarContent = (navbarPayload) => async (dispatch) => {
    dispatch({ type: Types.NAVBAR_CONTENT, payload: navbarPayload });
}

export const setNavbarBtnClick = (clickStatus) => async (dispatch) => {
    dispatch({ type: Types.NAVBAR_CONTENT_BTN_CLICK_STATUS, payload: clickStatus });
}